module.exports = __webpack_public_path__ + "static/media/sbahn-o-echtzeit.24517da6.svg";